import { downloadDocuments } from '@/utils';
import { PayloadAction } from '@reduxjs/toolkit';
import { all, call, put } from 'redux-saga/effects';

import * as API from 'services';

import { formatDefineDocumentAreaList } from './define-document-area.helper';
import { DefineDocumentAreaActions } from './define-document-area.redux';
import {
	TPayloadDeleteDocumentsRequest,
	TPayloadDownloadDocumentRequest,
	TPayloadGetDefineDocumentAreaListRequest,
	TPayloadUpdateDocumentItemRequest,
	TPayloadUploadDocumentRequest,
} from './define-document-area.type';

export function* getDefineDocumentAreaListByPage(
	action: PayloadAction<TPayloadGetDefineDocumentAreaListRequest>
) {
	const { callback, ...restParams } = action.payload;

	try {
		const res: API.ApiResponseSuccess<API.TGetDocumentListByPageResponse> =
			yield API.getDocumentByPage(restParams);
		const defineDocumentAreaList = formatDefineDocumentAreaList(
			res?.data?.content
		);

		yield put(
			DefineDocumentAreaActions.getDefineDocumentAreaListSuccess({
				defineDocumentAreaList,
				total: res?.data?.total,
				page: res?.data?.page,
			})
		);
		callback?.({ data: res.data?.total });
	} catch (error) {
		callback?.({ error });
		yield put(DefineDocumentAreaActions.getDefineDocumentAreaListFailure());
	}
}

export function* updateDocumentItem(
	action: PayloadAction<TPayloadUpdateDocumentItemRequest>
) {
	const { callback, data } = action.payload;

	try {
		yield API.updateDocumentItem(data);

		yield put(DefineDocumentAreaActions.updateDocumentItemSuccess());
		callback?.();
	} catch (error) {
		callback?.(error);
		yield put(DefineDocumentAreaActions.updateDocumentItemFailure());
	}
}

export function* deleteDocuments(
	action: PayloadAction<TPayloadDeleteDocumentsRequest>
) {
	const { callback, params } = action.payload;
	try {
		yield API.deleteDocuments(params);
		yield put(DefineDocumentAreaActions.deleteDocumentsSuccess());
		callback?.();
	} catch (error) {
		callback?.(error);
		yield put(DefineDocumentAreaActions.deleteDocumentsFailure());
	}
}

export function* downloadDocument(
	action: PayloadAction<TPayloadDownloadDocumentRequest>
) {
	const { callback, paths, pageType, zipFileName } = action.payload;
	try {
		const files: API.ApiResponseSuccess<Blob>[] = yield all(
			paths.map((path) => call(API.defineDocumentDownload, { ...path }))
		);

		yield downloadDocuments({ files, pageType, zipFileName });
		callback?.();

		yield put(DefineDocumentAreaActions.downloadDocumentsSuccess());
	} catch (error) {
		callback?.({});
		yield put(DefineDocumentAreaActions.downloadDocumentsFailure());
	}
}

export function* uploadDocument(
	action: PayloadAction<TPayloadUploadDocumentRequest>
) {
	const { callback, data } = action.payload;
	try {
		yield API.uploadDocument(data);

		yield put(DefineDocumentAreaActions.updateDocumentItemSuccess());
		callback?.();
	} catch (error) {
		callback?.(error);
		yield put(DefineDocumentAreaActions.updateDocumentItemFailure());
	}
}
